import React from 'react';
import Ball from './Ball';
import './Tube.css';

export default function Tube({ balls, capacity, isSelected, isHint, onClick, tubeIndex }) {
  const emptySlots = capacity - balls.length;

  return (
    <div
      className={`tube-wrap ${isSelected ? 'selected' : ''} ${isHint ? 'hint' : ''}`}
      onClick={onClick}
      role="button"
      aria-label={`Tube ${tubeIndex + 1}`}
    >
      <div className="tube-top-cap" />
      <div className="tube-body">
        {/* Empty slots */}
        {Array.from({ length: emptySlots }).map((_, i) => (
          <div key={`empty-${i}`} className="ball-slot empty" />
        ))}
        {/* Balls from top to bottom (reversed for display) */}
        {[...balls].reverse().map((color, i) => (
          <Ball
            key={`${color}-${i}`}
            color={color}
            isTop={i === 0}
            isSelected={isSelected && i === 0}
          />
        ))}
      </div>
      <div className="tube-bottom" />
      {isSelected && <div className="tube-select-glow" />}
    </div>
  );
}
